import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import { farmers } from "../../config/images";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import translations from "../../config/language";
import { Avatar, AvatarGroup } from "@mui/joy";

const mapContainerStyle = {
  height: "100vh",
};

function clampAvatars(avatars, maxVisible = 3) {
  const totalAvatars = avatars.length;
  const visibleAvatars = avatars.slice(0, maxVisible); // Show only 3
  const surplus = totalAvatars > maxVisible ? totalAvatars - maxVisible : 0; // Extra count
  return { avatars: visibleAvatars, surplus };
}

const LocationDetails = ({
  selectedFarmer,
  galleryIsOpen,
  setGalleryIsOpen,
}) => {
  const locationDetails = selectedFarmer?.location_details;

  // Sample coordinates (Replace with actual farmer coordinates)
  const latitude = parseFloat(locationDetails?.farmer_house_latitude);
  const longitude = parseFloat(locationDetails?.farmer_house_longitude);
  const isValidLocation = !isNaN(latitude) && !isNaN(longitude);
  const googleMapsApiKey =
    "AIzaSyAhALM3q3fyD_1T7sHMd2kSXwHAUSbSvf0&libraries=places"; // Replace with your API Key
  const [zoom, setZoom] = useState(16);
  const [imageIndex, setImageIndex] = useState(0);

  const mapOptions = {
    mapTypeId: "satellite",
    disableDefaultUI: true,
    zoomControl: true,
  };
  const language = process.env.REACT_APP_LANGUAGE;

  const [images, setImages] = useState([]);
  const handleGalleryOpen = (items, index) => {
    setGalleryIsOpen(true);
    setImages(items);
    setImageIndex(index);
  };
  const mapZoom = isValidLocation ? zoom : 4;
  return (
    <div className="user-profile">
      <Grid container>
        <Grid
          item
          lg={4}
          className="grid-item"
          style={{ borderTop: "1px solid #D9D9D9", paddingLeft: "20px" }}
        >
          {translations[language].address}
        </Grid>
        <Grid
          item
          lg={8}
          className="grid-item"
          style={{ borderTop: "1px solid #D9D9D9", fontWeight: 700 }}
        >
          {locationDetails.farmer_house_address}
        </Grid>
      </Grid>
      <Grid container>
        <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
          {translations[language].latitude}
        </Grid>
        <Grid item lg={5} className="grid-item" style={{ fontWeight: 700 }}>
          {isValidLocation ? `${latitude}, ${longitude}` : ""}

        </Grid>
        <Grid item lg={3} className="grid-item" style={{ fontWeight: 700, paddingBottom: "5px", paddingTop: "5px" }}>
          <div style={{ display: "flex", gap: "10px", fontWeight: 700, alignItems: "center" }}>
            <div>{locationDetails.farmer_house_size} Hectors</div>

            {locationDetails.farmer_house_photos.length > 0 && (
              <AvatarGroup sx={{ "--AvatarGroup-gap": "-16px" }}>
                {(() => {
                  const { avatars, surplus } = clampAvatars(
                    locationDetails.farmer_house_photos.map(
                      (photo) => photo.photo
                    ),
                    3
                  );
                  return (
                    <>
                      {avatars.map((photo, index) => (
                        <Avatar
                          key={index}
                          className="cursor-pointer"
                          sx={{ width: 35, height: 35 }}
                          onClick={() =>
                            handleGalleryOpen(
                              locationDetails.farmer_house_photos.map(
                                (photo) => photo.photo
                              ),
                              index
                            )
                          }
                        >
                          <img
                            src={photo || "/placeholder.svg"}
                            alt={`Attachment ${index + 1}`}
                            style={{
                              width: 35,
                              height: 35,
                              objectFit: "cover",
                            }}
                          />
                        </Avatar>
                      ))}
                      {surplus > 0 && (
                        <Avatar
                          sx={{
                            width: 35,
                            height: 35,
                            backgroundColor: "#3C4856",
                            color: "#FFFFFF",
                            fontSize: 14,
                            fontWeight: 400,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleGalleryOpen(
                              locationDetails.farmer_house_photos.map(
                                (photo) => photo.photo
                              ),
                              3
                            )
                          }
                        >
                          +{surplus}
                        </Avatar>
                      )}
                    </>
                  );
                })()}
              </AvatarGroup>
            )}
          </div>
        </Grid>
      </Grid>

      <Box mt={2}>
        <LoadScript googleMapsApiKey={googleMapsApiKey}>
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={{ lat: isValidLocation ? latitude : 20.5937, lng: isValidLocation ? longitude : 78.9629 }} // Default to India's center
            zoom={mapZoom}
            options={mapOptions}
          >
            {isValidLocation && (
              <Marker position={{ lat: latitude, lng: longitude }} onClick={() => setZoom(22)} />
            )}
          </GoogleMap>
        </LoadScript>
      </Box>
      {galleryIsOpen && (
        <ImageGallery
          images={images}
          isOpen={galleryIsOpen}
          onClose={() => setGalleryIsOpen(false)}
          imageIndex={imageIndex}
        />
      )}
    </div>
  );
};

export default LocationDetails;